import { render } from "./TextBlock.vue?vue&type=template&id=9f9f1cdc"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script